document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-email-signup-popup]');
  if (!popup) return;

  var overlay = popup.querySelector('[data-email-signup-overlay]');
  var closeButtons = popup.querySelectorAll('[data-email-signup-close]');
  var continueButton = popup.querySelector('[data-email-signup-continue]');
  var nextButton = popup.querySelector('[data-email-signup-next]');

  var form = popup.querySelector('[data-email-signup-form]');
  var messageEl = popup.querySelector('[data-email-signup-message]');
  var emailInput = form ? form.querySelector('input[name="email"]') : null;
  var submitButton = form ? form.querySelector('button[type="submit"]') : null;

  var smsForm = popup.querySelector('[data-email-signup-sms-form]');
  var smsMessageEl = popup.querySelector('[data-email-signup-sms-message]');
  var phoneInput = smsForm ? smsForm.querySelector('input[name="phone"]') : null;
  var smsConsentCheckbox = smsForm ? smsForm.querySelector('input[name="sms_consent"]') : null;
  var smsSubmitButton = smsForm ? smsForm.querySelector('button[type="submit"]') : null;

  var STORAGE_PREFIX = 'email_signup_popup_v1_';
  var CLOSED_KEY = STORAGE_PREFIX + 'closed_at';
  var SUBMITTED_KEY = STORAGE_PREFIX + 'submitted';
  var CLOSED_COOKIE = STORAGE_PREFIX + 'closed';
  var SUBMITTED_COOKIE = STORAGE_PREFIX + 'submitted';
  var ONE_DAY_MS = 24 * 60 * 60 * 1000;

  var delaySeconds = parseInt(popup.getAttribute('data-delay-seconds') || '8', 10);
  var closeDays = parseInt(popup.getAttribute('data-close-days') || '10', 10);
  var publicKey = (popup.getAttribute('data-klaviyo-public-key') || '').trim();
  var listId = (popup.getAttribute('data-klaviyo-list-id') || '').trim();
  var smsListId = (popup.getAttribute('data-klaviyo-sms-list-id') || '').trim() || listId;
  var defaultError = popup.getAttribute('data-default-error') || 'Please try again.';
  var smsCheckboxError = popup.getAttribute('data-sms-checkbox-error') ||
    "Please check the box to confirm you'd like text updates, or clear the mobile number to skip.";
  var smsPhoneError = popup.getAttribute('data-sms-phone-error') ||
    'Please enter a mobile number to receive text updates.';
  var smsInvalidPhoneError = popup.getAttribute('data-sms-invalid-phone-error') ||
    'Please enter a valid mobile number.';

  var storedEmail = '';

  function parseExcludedPaths(value) {
    if (!value) return [];
    return value
      .split('\n')
      .map(function (line) { return line.trim(); })
      .filter(function (line) { return line.length > 0; });
  }
  var excludedPaths = parseExcludedPaths(popup.getAttribute('data-excluded-paths'));

  function getCookie(name) {
    var target = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var cookie = parts[i].trim();
      if (cookie.indexOf(target) === 0) return cookie.substring(target.length);
    }
    return '';
  }
  function setCookie(name, value, maxAgeSeconds) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAgeSeconds;
  }
  function removeCookie(name) {
    document.cookie = name + '=; path=/; max-age=0';
  }
  function safeSetStorage(key, value) {
    try { localStorage.setItem(key, value); } catch (_) {}
  }
  function safeGetStorage(key) {
    try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
  }
  function safeRemoveStorage(key) {
    try { localStorage.removeItem(key); } catch (_) {}
  }

  function isAllowedPath(pathname) {
    if (pathname === '/') return true;
    if (pathname === '/collections' || pathname.indexOf('/collections/') === 0) return true;
    if (pathname === '/products' || pathname.indexOf('/products/') === 0) return true;
    if (pathname === '/blogs' || pathname.indexOf('/blogs/') === 0) return true;
    return false;
  }
  function isBlockedPath(pathname) {
    var blockedPrefixes = [
      '/cart', '/checkout', '/account', '/pages/contact',
      '/pages/wholesale', '/pages/find-a-stockist', '/pages/safety',
      '/pages/limited-warranty', '/pages/registration'
    ];
    for (var i = 0; i < blockedPrefixes.length; i += 1) {
      if (pathname === blockedPrefixes[i] || pathname.indexOf(blockedPrefixes[i] + '/') === 0) return true;
    }
    for (var j = 0; j < excludedPaths.length; j += 1) {
      var path = excludedPaths[j];
      if (pathname === path || pathname.indexOf(path + '/') === 0) return true;
    }
    return false;
  }

  function hasSubmittedSuppression() {
    return safeGetStorage(SUBMITTED_KEY) === '1' || getCookie(SUBMITTED_COOKIE) === '1';
  }
  function setSubmittedSuppression() {
    safeSetStorage(SUBMITTED_KEY, '1');
    setCookie(SUBMITTED_COOKIE, '1', 3650 * 24 * 60 * 60);
  }
  function hasClosedSuppression() {
    var now = Date.now();
    var closeMs = closeDays * ONE_DAY_MS;
    var closedAtRaw = safeGetStorage(CLOSED_KEY);
    var closedAt = closedAtRaw ? parseInt(closedAtRaw, 10) : 0;
    if (!closedAt) {
      var cookieAt = parseInt(getCookie(CLOSED_COOKIE) || '0', 10);
      closedAt = cookieAt || 0;
    }
    if (!closedAt) return false;
    if (now - closedAt >= closeMs) {
      safeRemoveStorage(CLOSED_KEY);
      removeCookie(CLOSED_COOKIE);
      return false;
    }
    return true;
  }
  function setClosedSuppression() {
    var now = Date.now();
    safeSetStorage(CLOSED_KEY, String(now));
    setCookie(CLOSED_COOKIE, String(now), closeDays * 24 * 60 * 60);
  }
  function isLikelyKnownKlaviyoProfile() {
    var rawKlaId = getCookie('__kla_id') || '';
    var klaId = rawKlaId;
    try { klaId = decodeURIComponent(rawKlaId); } catch (_) { klaId = rawKlaId; }
    if (klaId && (klaId.indexOf('@') !== -1 || klaId.indexOf('%40') !== -1 || klaId.indexOf('email') !== -1)) return true;
    try {
      if (Array.isArray(window._learnq)) {
        for (var i = 0; i < window._learnq.length; i += 1) {
          var item = window._learnq[i];
          if (!item || item[0] !== 'identify' || typeof item[1] !== 'object') continue;
          if (item[1].email || item[1].$email) return true;
        }
      }
    } catch (_) {}
    return false;
  }

  function showStep(stepName) {
    popup.classList.remove('is-capture', 'is-sms', 'is-success');
    if (stepName === 'capture') popup.classList.add('is-capture');
    if (stepName === 'sms') popup.classList.add('is-sms');
    if (stepName === 'success') popup.classList.add('is-success');
  }

  function transitionToStep(nextStep) {
    popup.classList.add('is-transitioning');
    window.setTimeout(function () {
      showStep(nextStep);
      popup.classList.remove('is-transitioning');
    }, 160);
  }

  function openPopup() {
    popup.style.display = 'block';
    popup.getBoundingClientRect();
    popup.classList.add('is-visible');
    document.body.classList.add('email-signup-popup-open');
    showStep('intro');
  }
  function closePopup(setCloseFlag) {
    popup.classList.remove('is-visible');
    document.body.classList.remove('email-signup-popup-open');
    if (setCloseFlag) setClosedSuppression();
    window.setTimeout(function () {
      if (!popup.classList.contains('is-visible')) {
        popup.style.display = 'none';
        showStep('intro');
      }
    }, 320);
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function setMessage(text, type) {
    if (!messageEl) return;
    messageEl.textContent = text || '';
    messageEl.classList.remove('is-error', 'is-success');
    if (type === 'error') messageEl.classList.add('is-error');
    if (type === 'success') messageEl.classList.add('is-success');
  }
  function setSmsMessage(text, type) {
    if (!smsMessageEl) return;
    smsMessageEl.textContent = text || '';
    smsMessageEl.classList.remove('is-error', 'is-success');
    if (type === 'error') smsMessageEl.classList.add('is-error');
    if (type === 'success') smsMessageEl.classList.add('is-success');
  }

  function normalizePhone(raw) {
    if (!raw) return null;
    var value = raw.trim();
    if (value.charAt(0) === '+') {
      var withPlus = '+' + value.slice(1).replace(/\D/g, '');
      return withPlus.length >= 11 ? withPlus : null;
    }
    var digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function submitToKlaviyo(email) {
    var payload = new URLSearchParams();
    payload.append('g', listId);
    payload.append('email', email);
    if (publicKey) {
      payload.append('$source', 'shopify_theme_popup');
      payload.append('a', publicKey);
    }
    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: payload.toString()
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo signup failed');
      return response.json();
    });
  }

  function submitSmsConsentToKlaviyo(phone) {
    if (!publicKey) return Promise.reject(new Error('Missing Klaviyo public key'));

    var profileAttributes = {
      phone_number: phone,
      subscriptions: {
        sms: { marketing: { consent: 'SUBSCRIBED' } }
      }
    };
    if (storedEmail) profileAttributes.email = storedEmail;

    var attributes = {
      custom_source: 'shopify_theme_popup_sms',
      profile: {
        data: {
          type: 'profile',
          attributes: profileAttributes
        }
      }
    };

    var body = {
      data: {
        type: 'subscription',
        attributes: attributes
      }
    };

    if (smsListId) {
      body.data.relationships = {
        list: { data: { type: 'list', id: smsListId } }
      };
    }

    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(publicKey), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-07-15'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok && response.status !== 202) throw new Error('Klaviyo SMS consent failed');
      return true;
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () { closePopup(true); });
  }
  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      closePopup(true);
    });
  });
  if (nextButton) {
    nextButton.addEventListener('click', function () {
      showStep('capture');
      if (emailInput) emailInput.focus();
    });
  }
  if (continueButton) {
    continueButton.addEventListener('click', function () { closePopup(false); });
  }

  if (form && emailInput && submitButton) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (emailInput.value || '').trim();
      setMessage('', '');
      if (!validateEmail(email)) {
        setMessage(defaultError, 'error');
        return;
      }
      if (!listId) {
        setMessage('Popup is not configured yet. Add a Klaviyo List ID in section settings.', 'error');
        return;
      }
      submitButton.disabled = true;
      submitToKlaviyo(email)
        .then(function (result) {
          var success = result && (result.success === true || result.message || result.data);
          if (!success) throw new Error('No success response');
          storedEmail = email;
          setSubmittedSuppression();
          if (smsForm) {
            transitionToStep('sms');
          } else {
            transitionToStep('success');
          }
        })
        .catch(function () {
          setMessage(defaultError, 'error');
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });
  }

  if (smsForm) {
    smsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      setSmsMessage('', '');

      var rawPhone = (phoneInput && phoneInput.value || '').trim();
      var consentChecked = !!(smsConsentCheckbox && smsConsentCheckbox.checked);

      if (!rawPhone && !consentChecked) {
        transitionToStep('success');
        return;
      }
      if (rawPhone && !consentChecked) {
        setSmsMessage(smsCheckboxError, 'error');
        return;
      }
      if (!rawPhone && consentChecked) {
        setSmsMessage(smsPhoneError, 'error');
        return;
      }
      var normalizedPhone = normalizePhone(rawPhone);
      if (!normalizedPhone) {
        setSmsMessage(smsInvalidPhoneError, 'error');
        return;
      }

      if (smsSubmitButton) smsSubmitButton.disabled = true;
      submitSmsConsentToKlaviyo(normalizedPhone)
        .catch(function (err) {
          if (window.console && console.error) console.error('SMS consent error:', err);
        })
        .finally(function () {
          if (smsSubmitButton) smsSubmitButton.disabled = false;
          transitionToStep('success');
        });
    });
  }

  var pathname = window.location.pathname || '/';
  var shouldDisplayPopup = false;
  try {
    shouldDisplayPopup =
      isAllowedPath(pathname) &&
      !isBlockedPath(pathname) &&
      !hasSubmittedSuppression() &&
      !hasClosedSuppression() &&
      !isLikelyKnownKlaviyoProfile();
  } catch (_) {
    shouldDisplayPopup = false;
  }
  if (!shouldDisplayPopup) return;

  window.setTimeout(function () {
    openPopup();
  }, Math.max(1, delaySeconds) * 1000);
});